import { FullWidthLayout } from "@/layouts";
import * as Styled from "./legalPolicies";

export const PrivacyScreen = () => {
  return (
    <FullWidthLayout id="free-trial" bgColor="var(--background-light)" borderColor="var(--on-primary-dark)">
      <Styled.LegalContainer className="animate__animated animate__fadeIn">
        <Styled.BoxContent>
          <h1 className="headline-large weight-medium">Privacy Policy</h1>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Who we are</h2>
          <p className="body-medium">
            CELLECT ENERGY S.L. (hereinafter &quot;CELLECT&quot; or “we”) in relation to the access, browsing and all other possible actions on the Web Site
            cellectenergy.com (hereinafter the &quot;Website&quot;), requires the reading and acceptance of its Legal Texts (Legal Notices, Terms and Conditions
            and Cookies Policy together with the present Privacy Policy).
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Data collected</h2>
          <p className="body-medium">
            While you (“You” or the “User”) are visiting the Website, we collect and process all or some of the following personal data (the “Personal Data”):
          </p>
          <ul>
            <li>
              Information you provide to us: personal information that you provide to us such as when you complete a form on our Website, including but not
              limited to, your first and last names, email address, and company.
            </li>
            <li>Our correspondence: if you contact us, we will typically keep a record of that correspondence.</li>
            <li>
              Survey information: we may also ask you to complete surveys that we use for research purposes. In such circumstances, we shall collect the
              information provided in the completed survey.
            </li>
            <li>
              Website and communication usage: details of your visits to the Website and information collected through cookies and other tracking technologies
              including, but not limited to, your IP address and domain name, your browser version and operating system, browser language, access time, traffic
              data, location data, web logs, movements on the Websites, referring web site addresses and other communication data. We may also collect
              information about the pages you view within the Websites and other actions you take while visiting us. In addition, we may also use such
              technologies to determine whether you’ve opened an e-mail or clicked on a link contained in an e-mail.
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Processing and legal basis</h2>
          <p className="body-medium">Your Personal Data shall be collected and processed for the following purposes:</p>
          <p className="body-medium">
            To deal with requests for information which may be sent through the contact form, thus managing the relationship between CELLECT and you.
          </p>
          <ul>
            <li>Legal basis: contract performance, legitimate interest (to enable us to perform our obligations and provide our services to you)</li>
          </ul>
          <p>
            To obtain consent for the sending of commercial communications and advertising related to the services offered by CELLECT, invitations to events and
            other initiatives of the firm which may be of interest to the User.
          </p>
          <ul>
            <li>Legal basis: consent, legitimate interest (to provide you with updated news in relation to our products and services)</li>
          </ul>

          <p>To study and improve the effective functioning, navigation and security of the Website and information systems.</p>
          <ul>
            <li>Legal basis: consent, legitimate interest (to improve our Website users’ experience)</li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Personal data retention</h2>
          <p className="body-medium">
            Our retention periods for personal data are based on business needs and legal requirements. We retain Personal Data for as long as is necessary for
            the processing purpose(s) for which the information was collected, and any other permissible and related purpose.
          </p>
          <p className="body-medium">
            When the Personal Data is no longer needed, we either irreversibly anonymize the data (and we may further retain and use the anonymized information)
            or securely destroy the data.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Data recipients</h2>
          <p className="body-medium">
            To fulfil your requests and carry out our activities, we or you may need to share your Personal Data within CELLECT, such as to the Sales,
            Communication, or Information technology teams.
          </p>
          <p className="body-medium">
            We may also share your Personal Data with our service providers who perform services on our behalf, for the purposes described in this Privacy
            Policy. These are our hosting providers, backend infrastructure providers, infrastructure monitoring providers, managing contacts and sending
            messages service providers, support and contact request management service providers, user database management service provider.{" "}
          </p>
          <p className="body-medium">
            We contractually require these service providers to both keep your personal data confidential and not use it for any purpose(s) other than those
            necessary for the performance of our agreement with them.
          </p>
          <p>The Personal Data is not shared with any other third-party recipients.</p>
          <p>No Personal Data is transferred outside the European Economic Area.</p>
        </Styled.BoxContent>

        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Security</h2>
          <p className="body-medium">
            No data transmission over the Internet or the Website can be guaranteed to be secure from intrusion. However, we maintain commercially reasonable
            physical, electronic and procedural safeguards to protect your Personal Data in accordance with data protection legislative requirements.
          </p>
          <p className="body-medium">
            All information you provide to us is stored on our or our subcontractors’ secure servers and accessed and used subject to our security policies and
            standards.
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Users’ rights</h2>
          <p className="body-medium">
            Users have the right to exercise at any time, under the terms provided by current legislation, the rights of access, rectification, or deletion of
            data, as well as to request the limitation of data processing, their opposition or portability of the same and not to be subject to automated
            decisions, including profiling. Likewise, Users may revoke the consent given at any time.
          </p>
          <p className="body-medium">
            The aforementioned rights may be exercised by sending an e-mail to the address info@cellectenergy.com specifying the following details: name and
            surname(s), address for the purpose of notifications, copy of ID card or passport.
          </p>
          <p className="body-medium">
            If you are not satisfied with our use of your Personal Data or our response to any exercise of these rights you have the right to complain to the
            Supervisory Authority of your usual place of residence or the place where the alleged breach to the law occurred. Please click here to see the list
            and contact information of the EU Supervisory Authorities:
            http://ec.europa.eu/justice/data-protection/article-29/structure/data-protection-authorities/index_en.htm
          </p>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <h2 className="headline-medium weight-medium">Modification</h2>
          <p className="body-medium">
            We may change the content of our Website and how we use Personal Data, and consequently, the present Privacy Policy may change from time to time in
            the future. If we change this Privacy Policy, we will update the date it was last changed below. If these changes are material, we will indicate
            this clearly on our Website.
          </p>
          <p className="body-medium">This Privacy Policy was last updated in August 2022.</p>
        </Styled.BoxContent>
      </Styled.LegalContainer>
    </FullWidthLayout>
  );
};
